"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
exports.__esModule = true;
exports.IconBackspace = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var IconBackspace = function (_a) {
    var _b = _a.size, size = _b === void 0 ? '24px' : _b, style = _a.style;
    return ((0, jsx_runtime_1.jsx)("div", __assign({ style: __assign(__assign({ display: 'inline-flex', alignItems: 'center', justifyContent: 'center' }, style), { height: size, width: size }) }, { children: (0, jsx_runtime_1.jsx)("div", __assign({ style: {
                position: 'relative',
                height: 0,
                width: '100%',
                padding: 0,
                paddingBottom: '100%'
            } }, { children: (0, jsx_runtime_1.jsx)("svg", __assign({ style: {
                    position: 'absolute',
                    height: '100%',
                    width: '100%',
                    left: 0,
                    top: 0
                }, viewBox: "0 0 512 512", xmlns: "http://www.w3.org/2000/svg" }, { children: (0, jsx_runtime_1.jsx)("path", { d: "M403.13 96H156.87a44.9 44.9 0 00-33.68 15.27 15.88 15.88 0 00-1.91 2.7L32 247.75a16 16 0 000 16.5l89.15 133.57a16.24 16.24 0 002 2.88 44.89 44.89 0 0033.7 15.3h246.28A44.92 44.92 0 00448 371.13V140.87A44.92 44.92 0 00403.13 96zM348 311a16 16 0 11-22.63 22.62L271.67 280 218 333.65A16 16 0 01195.35 311L249 257.33l-53.69-53.69A16 16 0 01218 181l53.69 53.7 53.67-53.7A16 16 0 01348 203.64l-53.7 53.69z", fill: "currentColor" }, void 0) }), void 0) }), void 0) }), void 0));
};
exports.IconBackspace = IconBackspace;
